module.exports = __webpack_public_path__ + "img/informe-de-coordinación-csee.290aca37.svg";